import productWaitlistService from './productWaitlistService'
export default productWaitlistService



// WEBPACK FOOTER //
// ../src/services/productWaitlistService/index.js